<div #trigger="cdkOverlayOrigin" (click)="toggle()" cdkOverlayOrigin class="w-full">
  <div [class.flex-row-reverse]="reverse" [class.flex-row]="!reverse" class="input-container gap-2">
    <img [class.filter-neutral-500]="displayValue"
         [class.h-4]="compact"
         [class.h-5]="!compact" [class.w-4]="compact"
         [class.w-5]="!compact" alt="calendar"
         class="filter-neutral-400" src="/assets/icons/feather/calendar.svg">
    <span [class.cd-text-b2]="!compact"
          [class.cd-text-b3]="compact"
          [class.filter-neutral-500]="displayValue"
          class="mr-auto truncate"
          style="color: var(--color-neutral-400)">{{ displayValue || placeholder }}</span>
  </div>
</div>

<ng-template
  (backdropClick)="isOpen = false"
  (detach)="isOpen = false"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayOpen]="isOpen"
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayPositions]="[
        { originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top' },
        { originX: 'start', originY: 'top', overlayX: 'start', overlayY: 'bottom' }
      ]"
  backdropClass="datepicker-backdrop"
  cdkConnectedOverlay
>
  <div (click)="$event.stopPropagation()" class="picker-panel custom-datepicker-panel flex flex-col lg:flex-row overflow-hidden">
    <!-- Panel Lateral de Presets -->
    @if (range) {
      <div
        class="presets-panel border-b lg:border-b-0 lg:border-r border-neutral-200 p-2 flex flex-row lg:flex-col gap-1 overflow-x-auto lg:overflow-x-visible whitespace-nowrap lg:whitespace-normal">
        @for (preset of presets; track preset.label) {
          <button (click)="selectPreset(preset)"
                  class="preset-item text-left px-3 py-2 text-xs hover:bg-primary-50 rounded-md transition-colors text-neutral-700"
                  type="button">
            {{ preset.label }}
          </button>
        }
      </div>
    }

    <div class="relative p-4">
      @if (!range) {
        <div class="calendar-controls">
          <div class="nav-group">
            <button (click)="prevYear()" class="btn-nav" type="button" title="Año anterior">
              <img alt="Año anterior" class="h-4 w-4 filter-neutral-600" src="/assets/icons/feather/chevrons-left.svg">
            </button>
            <button (click)="prevMonth()" class="btn-nav" type="button" title="Mes anterior">
              <img alt="Mes anterior" class="h-4 w-4 filter-neutral-600" src="/assets/icons/feather/chevron-left.svg">
            </button>
          </div>
          <div class="month-title">{{ getMonthName(viewDate) }}</div>
          <div class="nav-group">
            <button (click)="nextMonth()" class="btn-nav" type="button" title="Mes siguiente">
              <img alt="Mes siguiente" class="h-4 w-4 filter-neutral-600" src="/assets/icons/feather/chevron-right.svg">
            </button>
            <button (click)="nextYear()" class="btn-nav" type="button" title="Año siguiente">
              <img alt="Año siguiente" class="h-4 w-4 filter-neutral-600" src="/assets/icons/feather/chevrons-right.svg">
            </button>
          </div>
        </div>
      } @else {
        <div class="calendar-controls range-controls">
          <div class="nav-group">
            <button (click)="prevYear()" class="btn-nav" type="button" title="Año anterior">
              <img alt="Año anterior" class="h-4 w-4 filter-neutral-600" src="/assets/icons/feather/chevrons-left.svg">
            </button>
            <button (click)="prevMonth()" class="btn-nav" type="button" title="Mes anterior">
              <img alt="Mes anterior" class="h-4 w-4 filter-neutral-600" src="/assets/icons/feather/chevron-left.svg">
            </button>
          </div>
          <div class="month-title">{{ getMonthName(viewDate) }}</div>
          <div class="month-title">{{ getMonthName(nextMonthDate) }}</div>
          <div class="nav-group">
            <button (click)="nextMonth()" class="btn-nav" type="button" title="Mes siguiente">
              <img alt="Mes siguiente" class="h-4 w-4 filter-neutral-600" src="/assets/icons/feather/chevron-right.svg">
            </button>
            <button (click)="nextYear()" class="btn-nav" type="button" title="Año siguiente">
              <img alt="Año siguiente" class="h-4 w-4 filter-neutral-600" src="/assets/icons/feather/chevrons-right.svg">
            </button>
          </div>
        </div>
      }

      <div [class.is-range]="range" class="calendars-container">
        <!-- Primer Calendario -->
        <div class="calendar">
          <div class="days-grid">
            @for (day of daysOfWeek; track day) {
              <div class="day-name">{{ day }}</div>
            }
            @for (date of daysOfMonth; track $index) {
              <div
                (click)="selectDate(date)"
                [class.empty]="!date"
                [class.in-range]="isInRange(date)"
                [class.is-today]="isToday(date)"
                [class.selected]="isSelected(date)"
                class="day-cell"
              >
                {{ date ? date.date() : '' }}
              </div>
            }
          </div>
        </div>

        <!-- Segundo Calendario (Solo en modo rango) -->
        @if (range) {
          <div class="calendar">
            <div class="days-grid">
              @for (day of daysOfWeek; track day) {
                <div class="day-name">{{ day }}</div>
              }
              @for (date of daysOfNextMonth; track $index) {
                <div
                  (click)="selectDate(date)"
                  [class.empty]="!date"
                  [class.in-range]="isInRange(date)"
                  [class.is-today]="isToday(date)"
                  [class.selected]="isSelected(date)"
                  class="day-cell"
                >
                  {{ date ? date.date() : '' }}
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</ng-template>
